import { render } from "./formBuilder2.vue?vue&type=template&id=692cfa01"
import script from "./formBuilder2.vue?vue&type=script&lang=js"
export * from "./formBuilder2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__